export const environment = {
  production: false,
  apiUrl: 'https://dev-cat-fngcg5gudwe7aucv.westus2-01.azurewebsites.net/api/',
  // apiUrl: 'http://localhost:5292/api/',
};
